// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-progress-bar{
    height: 2px;
    z-index: 1000;
    position: fixed;
}
.apiLoader{
    display: none;
    z-index: 1000;
    position: fixed;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInNlY3VyZS1sYXlvdXQuY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLFdBQVc7SUFDWCxhQUFhO0lBQ2IsZUFBZTtBQUNuQjtBQUNBO0lBQ0ksYUFBYTtJQUNiLGFBQWE7SUFDYixlQUFlO0FBQ25CIiwiZmlsZSI6InNlY3VyZS1sYXlvdXQuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi5tYXQtcHJvZ3Jlc3MtYmFye1xuICAgIGhlaWdodDogMnB4O1xuICAgIHotaW5kZXg6IDEwMDA7XG4gICAgcG9zaXRpb246IGZpeGVkO1xufVxuLmFwaUxvYWRlcntcbiAgICBkaXNwbGF5OiBub25lO1xuICAgIHotaW5kZXg6IDEwMDA7XG4gICAgcG9zaXRpb246IGZpeGVkO1xufSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/secure/secure-layout/secure-layout.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,eAAe;AACnB;AACA;IACI,aAAa;IACb,aAAa;IACb,eAAe;AACnB;AACA,gjBAAgjB","sourcesContent":[".mat-progress-bar{\n    height: 2px;\n    z-index: 1000;\n    position: fixed;\n}\n.apiLoader{\n    display: none;\n    z-index: 1000;\n    position: fixed;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
